import BillingInfoFormQuotation from "../../components/Forms/billing-info-form";
import PersonnalInfoForm from "../../components/Forms/personnal-info-form";
import { useTranslation } from 'react-i18next';
import Hr from "../../components/Style/hr";
import { useState } from "react";
import ExplanationStep from "./explanation-step";
import Button from "../../components/Buttons/button";
import ButtonSecondary from "../../components/Buttons/button-secondary";
import { useCart } from "../../contexts/cart-context";

export default function StepPersonnalsInfos({ returnedData }) {
    const { t } = useTranslation();
    const { cart } = useCart();

    /* Personnal infos */
    const [personnalInfoFormData, setPersonnalInfoFormData] = useState({
        lastname: "",
        firstname: "",
        email: "",
        phone: ""
    });
    const [errorsPersonnalInfo, setErrorsPersonnalInfo] = useState({});

    const updatePersonnalInfoFormData = (newData) => {
        setPersonnalInfoFormData(newData);
    };

    /* Billing info */
    const [billingInfoFormData, setBillingInfoFormData] = useState({
        nameSociety: "",
        siret: "",
        numTVA: "",
        country: "",
        city: "",
        address: "",
        postalCode: "",
        address2: ""
    });
    const [errorsBillingInfo, setErrorsBillingInfo] = useState({});

    const updateBillingInfoFormData = (newData) => {
        setBillingInfoFormData(newData);
    };

    const validateForms = () => {
        const requiredMsg = t('inputs.required') || 'Ce champ est obligatoire.';

        const pErrors = {};
        const bErrors = {};

        // --- Infos perso obligatoires ---
        if (!personnalInfoFormData.lastname?.trim()) {
            pErrors.lastname = requiredMsg;
        }
        if (!personnalInfoFormData.firstname?.trim()) {
            pErrors.firstname = requiredMsg;
        }
        if (!personnalInfoFormData.email?.trim()) {
            pErrors.email = requiredMsg;
        }
        if (!personnalInfoFormData.phone?.trim()) {
            pErrors.phone = requiredMsg;
        }

        // --- Infos facturation obligatoires ---
        if (!billingInfoFormData.country?.trim()) {
            bErrors.country = requiredMsg;
        }
        if (!billingInfoFormData.city?.trim()) {
            bErrors.city = requiredMsg;
        }
        if (!billingInfoFormData.address?.trim()) {
            bErrors.address = requiredMsg;
        }
        if (!billingInfoFormData.postalCode?.trim()) {
            bErrors.postalCode = requiredMsg;
        }

        setErrorsPersonnalInfo(pErrors);
        setErrorsBillingInfo(bErrors);

        const hasErrors =
            Object.keys(pErrors).length > 0 ||
            Object.keys(bErrors).length > 0;

        return !hasErrors;
    };

    const handleSubmit = () => {
        const isValid = validateForms();
        if (!isValid) return;

        // On ne crée PAS le paiement ici, on envoie juste les infos au parent
        returnedData({
            type: 'SUBMIT_INFOS',
            payload: {
                personnalInfo: personnalInfoFormData,
                billingInfo: billingInfoFormData,
                cart, // optionnel, tu peux aussi le reprendre depuis le context dans Cart
            }
        });
    };

    const handleBack = () => {
        returnedData && returnedData('check');
    };

    return (
        <>
            <div className="flex gap-40">
                <div className="flex flex-col gap-5" style={{ flex: "0 0 256px" }}>
                    <ExplanationStep
                        title={t('cart.stepPersonnalsInfos.title')}
                        description={t('cart.stepPersonnalsInfos.description')}
                    />
                </div>

                <div className="flex flex-col w-full">
                    <PersonnalInfoForm
                        customer={personnalInfoFormData}
                        errors={errorsPersonnalInfo}
                        updatePersonnalInfoFormData={updatePersonnalInfoFormData}
                    />

                    <Hr />

                    <BillingInfoFormQuotation
                        data={billingInfoFormData}
                        errors={errorsBillingInfo}
                        updateBillingInfoFormData={updateBillingInfoFormData}
                    />
                </div>
            </div>

            <div className="mt-8 w-full flex justify-between gap-4">
                <ButtonSecondary
                    text={t('cart.back') || 'Retour'}
                    onClick={handleBack}
                />
                <Button
                    text={t('cart.paiement')}
                    onClick={handleSubmit}
                />
            </div>
        </>
    );
};